module.exports = __webpack_public_path__ + "img/money.1af5bb04.png";